// src/components/Header.js
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";

import adviceDefaultLogo from "../assets/images/adviceEv-logo.png";
import "../styles/components/header.css";

const HeaderComponent = ({ chargePointReducer }) => {
  const location = useLocation();
  const [logoUrl, setLogoUrl] = useState();

  useEffect(() => {
    if ((location.pathname, location.pathname.includes("company", "chargePoint"))) {
      const { chargePoint } = chargePointReducer;
      if (chargePoint) {
        const { company } = chargePoint;
        if (company && company.logoUrl) setLogoUrl(company.logoUrl);
      }
    }
  }, [chargePointReducer.chargePoint]);

  return (
    <header className="headerContainer">
      <div className="logoContainer">
        <img src={logoUrl ? logoUrl : adviceDefaultLogo} />
      </div>
    </header>
  );
};

const mapStateToProps = (state) => ({
  chargePointReducer: state.chargePointReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent);
